import { BaseItem, TableProps } from '@lib/components/Table/types';

export const checkHasActionsColumn = <T extends BaseItem>({
  actions,
}: TableProps<T>): boolean => !!actions?.length;
